const brands = [
  'Miyuki',
  'Preciosa',
  'Londonderry',
];

export default brands;
